<div class="empty-state" [class.card]="variant === 'card'">
  <div class="content" [class.content-center]="variant === 'card' && cardCopyAlignment === 'center'">
    @if (variant === 'card') {
      <div class="card-copy" [class.card-copy-center]="cardCopyAlignment === 'center'">
        <span
          class="card-status"
          [class.card-status-limited]="cardStatusVariant === 'limited'"
          [class.card-status-empty]="cardStatusVariant === 'empty'"
        >
          {{ cardStatusLabel }}
        </span>
        <h1 class="card-title text-grey-mid">{{ title }}</h1>
        <p class="card-description">{{ description }}</p>
        <ng-content></ng-content>
      </div>
      <ion-icon [name]="contextIcon"></ion-icon>
    } @else {
      @if (!customContextName) {
        <h1 class="text-grey-mid">
          No <span class="lowercase">{{ contextName }} </span>yet
        </h1>
      } @else {
        <h1 class="text-grey-mid">{{ title }}</h1>
      }

      <p class="text-sm">{{ description }}</p>

      <ng-content></ng-content>
      <ion-icon [name]="contextIcon"></ion-icon>
    }
  </div>
</div>
